var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292068 0.292941C0.105262 0.481833 0.000488281 0.736777 0.000488281 1.00244C0.000488281 1.2681 0.105262 1.52305 0.292068 1.71194L3.23107 4.67694C3.44907 4.89194 3.73107 4.99894 4.01007 4.99894C4.28907 4.99894 4.56607 4.89194 4.77907 4.67694L7.70907 1.72194C7.89563 1.53292 8.00024 1.27803 8.00024 1.01244C8.00024 0.746856 7.89563 0.49196 7.70907 0.302941C7.61724 0.209757 7.5078 0.135759 7.38711 0.0852509C7.26642 0.0347429 7.1369 0.0087328 7.00607 0.0087328C6.87524 0.0087328 6.74571 0.0347429 6.62503 0.0852509C6.50434 0.135759 6.3949 0.209757 6.30307 0.302941L4.00507 2.61994L1.69807 0.292941C1.60603 0.20012 1.49652 0.126444 1.37586 0.0761652C1.25521 0.0258864 1.12578 0 0.995069 0C0.864353 0 0.734931 0.0258864 0.614272 0.0761652C0.493613 0.126444 0.384105 0.20012 0.292068 0.292941Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown0);
export default __webpack_public_path__ + "static/media/chevron-down-0.e6c2d4961ded10d299abf97a6bbadb81.svg";
export { ForwardRef as ReactComponent };